export const DEFAULT_IDP = 'myosh-default'; // The MyOSH IdP provider
